export default __webpack_public_path__ + "static/media/48.076a81d7.svg";